// Tạo ra các constant type để sử dụng trong action và reducer

export const FILTER_TODO = "FILTER_TODO";
export const ADD_TODO = "ADD_TODO";
export const DELETE_TODO = "DELETE_TODO";
export const CHANGE_STATUS = "CHANGE_STATUS";